module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "error"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pages_maincontent"
    }
  }, [_c('div', {
    staticClass: "error-wrapper"
  }, [_c('h1', [_vm._v(" Ooops:(")]), _vm._v(" "), _c('blockquote', [_vm._v("\n        Something went wrong\n      ")])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db1eb12e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db1eb12e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/error.vue
// module id = 872
// module chunks = 0